import React from 'react';

import { FormDialog, IFormDialogProps } from '@components';

import { Box, Stack, Typography } from '@mui/material';

interface ICandidateSuccessModalProps {
  header: Pick<IFormDialogProps, 'label' | 'subLabel'>;
  isOpen: boolean;
  isPassed: boolean;
  label: React.ReactNode;
  subLabel: React.ReactNode;
  handleClose: () => void;
}

export const CandidateSuccessModal: React.FC<ICandidateSuccessModalProps> = ({
  header,
  isOpen,
  isPassed,
  label,
  subLabel,
  handleClose,
}) => {
  return (
    <FormDialog
      isOpen={isOpen}
      {...header}
      isLoading={false}
      onSubmit={handleClose}
      onClose={handleClose}
      submitBtnLabel="Done"
      hideCancelBtn
    >
      <Stack gap="1.5rem">
        <Box
          sx={(theme) => ({
            background: theme.palette.highlight.sectionLight,
            borderRadius: '8px',
            padding: '48px 63px 72px 63px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '14px',
          })}
        >
          {isPassed && (
            <img
              src="https://ae-cp-static-files.s3.eu-central-1.amazonaws.com/client-dashboard/star.png"
              alt="star"
              width="57px"
              height="57px"
            />
          )}
          {label && (
            <Typography variant="h6" textAlign="center">
              {label}
            </Typography>
          )}
          {subLabel && (
            <Typography
              variant="body2"
              color="text.secondary"
              textAlign="center"
            >
              {subLabel}
            </Typography>
          )}
        </Box>
      </Stack>
    </FormDialog>
  );
};
